export default __webpack_public_path__ + "static/media/Diamond_Edge_large_11.c6abe2e2.jpg";